import HttpClient from '@/common/boot/HttpClient'

const listarRegistros = async ({ commit }, payload) => {
  commit('CARREGANDO', true)

  try {
    const response = await HttpClient.post('/pco-workflows-temp/visualizar', payload)
    const paginatedData = response.data.data || {}

    commit('LISTAR_DADOS', paginatedData)
    return response
  } catch (error) {
    console.error('Erro ao listar registros da pco_workflow_temp:', error)
    throw error
  } finally {
    commit('CARREGANDO', false)
  }
}

const buscarConfiguracaoIntegracao = async ({ commit }) => {
  commit('CARREGANDO_CONFIGURACAO', true)

  try {
    const response = await HttpClient.get('/pco-workflows/recuperacao/integracao/configuracao')
    commit('DEFINIR_CONFIGURACAO_INTEGRACAO', response.data.data)
    return response
  } finally {
    commit('CARREGANDO_CONFIGURACAO', false)
  }
}

const atualizarConfiguracaoIntegracao = async ({ commit }, payload) => {
  commit('CARREGANDO_CONFIGURACAO', true)

  try {
    const response = await HttpClient.patch('/pco-workflows/recuperacao/integracao/configuracao', payload)
    commit('DEFINIR_CONFIGURACAO_INTEGRACAO', response.data.data)
    return response
  } finally {
    commit('CARREGANDO_CONFIGURACAO', false)
  }
}

const buscarDashboardCentroFuncional = async ({ commit }, params = {}) => {
  commit('CARREGANDO_DASHBOARD', true)

  try {
    const response = await HttpClient.get('/pco-workflows/recuperacao/dashboard/centro-funcional', { params })
    commit('DEFINIR_DASHBOARD_CENTRO_FUNCIONAL', response.data.data)
    return response
  } catch (error) {
    commit('DEFINIR_DASHBOARD_CENTRO_FUNCIONAL', null)
    throw error
  } finally {
    commit('CARREGANDO_DASHBOARD', false)
  }
}

export {
  listarRegistros,
  buscarConfiguracaoIntegracao,
  atualizarConfiguracaoIntegracao,
  buscarDashboardCentroFuncional
}